module.exports = __webpack_public_path__ + "static/media/pop.3a210796.jpeg";